import { render, staticRenderFns } from "./ggDropdownItem.vue?vue&type=template&id=1908a372&scoped=true"
import script from "./ggDropdownItem.vue?vue&type=script&lang=js"
export * from "./ggDropdownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908a372",
  null
  
)

export default component.exports